export default __webpack_public_path__ + "static/media/linkedin.ecc2c97a.svg";